import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CacBaseDialogComponent, CacButtonComponent, ButtonClickEvent } from '@controladad/ng-base';

export interface RefundConfirmationDialogData {
  message?: string;
}

export type RefundConfirmationDialogResult = boolean | null;

@Component({
  selector: 'lib-refund-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, CacButtonComponent],
  templateUrl: './refund-confirmation-dialog.component.html',
  styles: [`
    .refund-dialog-wrapper {
      min-width: 400px;
      max-width: 500px;
    }

    .dialog-header {
      padding: 1.5rem;
      border-bottom: 1px solid #e5e7eb;
    }

    .dialog-title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      color: #111827;
    }

    .refund-dialog-content {
      padding: 1.5rem;
    }

    .message {
      margin-bottom: 2rem;
      line-height: 1.5;
      color: #374151;
      font-size: 0.95rem;
    }

    .actions {
      display: flex;
      gap: 1rem;
      justify-content: flex-end;
    }
  `]
})
export class RefundConfirmationDialogComponent extends CacBaseDialogComponent<
  RefundConfirmationDialogData,
  RefundConfirmationDialogResult
> {
  getMessage(): string {
    return this.data?.message || 'The changes you made may affect the order total. Do you want to refund the difference to the customer\'s wallet if applicable?';
  }

  onRefund(e: ButtonClickEvent) {
    e.setLoading(false);
    this.submit(true);
  }

  onNoRefund(e: ButtonClickEvent) {
    e.setLoading(false);
    this.submit(false);
  }
}
